import { Input, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Apis from '../../../../api';
import HSButton from '../../../common/Button';
import LinkButton from '../../../common/LinkButton';
import { dealStatus } from '../../../login/utils/Status';
import MessageActions from '../../../message/redux/actions';
import { Deal } from '../redux/types';
import CommonUtils from '../utils';

const { Option } = Select;

type Props = {
    deal: Deal;
};

const InterestedModal: React.FC<Props> = ({ deal }) => {
    const [open, setOpen] = useState(false);
    const [currencyCode, setCurrencyCode] = useState<string | undefined>(undefined);
    const [amount, setAmount] = useState<undefined | number>(undefined);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (deal.info.summary?.currencies && deal.info.summary?.currencies.length > 0 && open) {
            setCurrencyCode(deal.info.summary?.currencies[0]);
        }
    }, [deal, open]);

    const onClickCancel = () => {
        setOpen(false);
        setAmount(undefined);
        setCurrencyCode(undefined);
    };

    const onChangeCurrency = (value: string | undefined) => {
        setCurrencyCode(value);
    };

    const onChangeAmountNumber = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | { name?: string; value: unknown }>,
    ) => {
        const reg = /^\d+$/;
        const targetValue = String(event.target.value).replace(new RegExp(',', 'g'), '');
        if (targetValue === '') {
            setAmount(undefined);
            return;
        }
        if (reg.test(String(targetValue))) {
            setAmount(parseInt(String(targetValue)));
        }
    };

    const onSubmit = () => {
        setLoading(true);
        Apis.dealInvestmentInterest(deal.uuid, {
            dealUUID: deal.uuid,
            amount: amount
                ? {
                      amountUpto2dp: amount,
                      currency: currencyCode,
                  }
                : undefined,
        })
            .then(() => {
                dispatch(
                    MessageActions.showMessage({
                        error: false,
                        text: 'Your interest has been successfully registered',
                    }),
                );
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                onClickCancel();
                setLoading(false);
            });
    };

    return (
        <>
            {/* <HSButton
                title="I'm Interested"
                onClick={() => setOpen(true)}
                disabled={deal.status !== dealStatus.active}
            /> */}

            <LinkButton
                title="I'm Interested"
                isArrow={true}
                disabled={deal.status !== dealStatus.active}
                onClick={() => setOpen(true)}
            />

            <Modal
                open={open}
                title="Request a Call Back"
                footer={[<HSButton title="submit" onClick={onSubmit} loading={loading} />]}
                onCancel={onClickCancel}
                onOk={onClickCancel}
                className="interest_modal"
            >
                <p className="text-sm font-[WorkSans] text-[#20222B]">
                    Thank you for your interest. Please provide the indicative amount you would like to invest. Our team
                    will get back to you shortly to assist on this.
                </p>
                <div className="w-auto py-2">
                    {/* <label className="SourceSansPro-SemiBold text-base">Amount (Optional)</label> */}
                    <Input.Group compact className="phone_number mt-2">
                        <div className="w-1/3">
                            <Select
                                onChange={onChangeCurrency}
                                optionFilterProp="children"
                                value={currencyCode}
                                className="w-full"
                            >
                                {deal.info.summary?.currencies?.map((d, index) => (
                                    <Option key={`${d}_${index}`} value={d}>
                                        {d}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="w-2/3">
                            <Input
                                placeholder="Enter Amount (Optional)"
                                value={amount ? CommonUtils.commaSeperator(String(amount)) : ''}
                                onChange={onChangeAmountNumber}
                                onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                            />
                        </div>
                    </Input.Group>
                </div>
                {/* <div className="flex justify-end py-4 bg-[#EFEEEC]">
                    <HSButton title="submit" onClick={onSubmit} loading={loading} />
                </div> */}
            </Modal>
        </>
    );
};

export default InterestedModal;
